export var Achievement = /*#__PURE__*/function (Achievement) {
  Achievement["greenDays40"] = "greenDays40";
  Achievement["greenDays50"] = "greenDays50";
  Achievement["greenDays60"] = "greenDays60";
  Achievement["greenDays70"] = "greenDays70";
  Achievement["cycles10"] = "cycles10";
  Achievement["cycles50"] = "cycles50";
  Achievement["cycles100"] = "cycles100";
  Achievement["year1"] = "year1";
  Achievement["year10"] = "year10";
  Achievement["firstTemperatureMeasurement"] = "firstTemperatureMeasurement";
  Achievement["firstDisabledMeasurement"] = "firstDisabledMeasurement";
  Achievement["ovulation"] = "ovulation";
  Achievement["sexPlan"] = "sexPlan";
  Achievement["sexPrevent"] = "sexPrevent";
  Achievement["lhRecommendation"] = "lhRecommendation";
  Achievement["lhResult"] = "lhResult";
  Achievement["pregRecommendation"] = "pregRecommendation";
  Achievement["pregResult"] = "pregResult";
  Achievement["upgradedAccount"] = "upgradedAccount";
  Achievement["fiveInAWeek"] = "fiveInAWeek";
  Achievement["twentyInAMonth"] = "twentyInAMonth";
  Achievement["signupAndInstallTheApp"] = "signupAndInstallTheApp";
  Achievement["helpedNCResearch"] = "helpedNCResearch";
  Achievement["calibratedThermometer"] = "calibratedThermometer";
  Achievement["verifiedEmail"] = "verifiedEmail";
  Achievement["viewedInstrVideo"] = "viewedInstrVideo";
  Achievement["referredFriend"] = "referredFriend";
  Achievement["completedAppTour"] = "completedAppTour";
  Achievement["reportedABug"] = "reportedABug";
  Achievement["readGuideMeasure"] = "readGuideMeasure";
  Achievement["readGuideOvulation"] = "readGuideOvulation";
  Achievement["readGuideCervicalMucus"] = "readGuideCervicalMucus";
  Achievement["readGuideCervicalMucusPregnant"] = "readGuideCervicalMucusPregnant";
  Achievement["readGuideLh"] = "readGuideLh";
  Achievement["readGuideEffectiveness"] = "readGuideEffectiveness";
  Achievement["readGuideBreastCheck"] = "readGuideBreastCheck";
  Achievement["readGuideUebe"] = "readGuideUebe";
  Achievement["readGuideHbc"] = "readGuideHbc";
  Achievement["readGuideMenstrualCycle"] = "readGuideMenstrualCycle";
  Achievement["readGuideOura"] = "readGuideOura";
  Achievement["readGuideT3"] = "readGuideT3";
  Achievement["readGuideAppleWatch"] = "readGuideAppleWatch";
  Achievement["readGuideB1"] = "readGuideB1";
  Achievement["readGuideMeasuringOvernight"] = "readGuideMeasuringOvernight";
  Achievement["readGuideChildbirthExpectations"] = "readGuideChildbirthExpectations";
  Achievement["readGuideChildbirthSexlife"] = "readGuideChildbirthSexlife";
  Achievement["readGuideChildbirthSleep"] = "readGuideChildbirthSleep";
  Achievement["readGuidePelvicFloor"] = "readGuidePelvicFloor";
  Achievement["quizMeasuring"] = "quizMeasuring";
  Achievement["quizLh"] = "quizLh";
  Achievement["quizPeriod"] = "quizPeriod";
  Achievement["quizCycle"] = "quizCycle";
  Achievement["quizFollicular"] = "quizFollicular";
  Achievement["quizVulva"] = "quizVulva";
  Achievement["cardsPregLoss"] = "cardsPregLoss";
  Achievement["cardsUnplannedPreg"] = "cardsUnplannedPreg";
  Achievement["cardsLatePeriods"] = "cardsLatePeriods";
  Achievement["cardsHbcQuit"] = "cardsHbcQuit";
  Achievement["cardsPpFertility"] = "cardsPpFertility";
  Achievement["cardsChildbirthPrepare"] = "cardsChildbirthPrepare";
  Achievement["cardsPpMentalHealth"] = "cardsPpMentalHealth";
  Achievement["cardsPpBackToWork"] = "cardsPpBackToWork";
  Achievement["cardsFeedingBaby"] = "cardsFeedingBaby";
  return Achievement;
}(Achievement || {});